import { module } from 'angular';
import BatchRoute from './batch.component';

export default module('app.batch', [])
	.component('batchRoute', BatchRoute)
	.name;
